import { FormSelect, IFormSelectProps, ISelectOption } from '../Select'
import FilterField, { FILTER_CONTROL_SIZE, IFilterLayoutProps } from './FilterField'

export type IFilterSelectOption = ISelectOption

export interface IFilterSelectProps
  extends Omit<IFormSelectProps, 'size' | 'placeholder' | 'hideEmptyOption'>, IFilterLayoutProps {
  label: string
  /**
   * Rótulo da opção vazia. "Todos" é o padrão do painel — um filtro em branco não filtra nada,
   * e não é um convite a escolher. Use "Todas" quando o substantivo for feminino.
   */
  emptyLabel?: string
}

/**
 * Select da barra de filtros: o `<FormSelect>` na altura da barra, dentro do `<FilterField>`.
 *
 * A opção vazia é a mesma mecânica do formulário — o que muda é o rótulo padrão, porque aqui ela
 * quer dizer "não filtrar" e não "escolha alguma coisa".
 *
 * Para listas longas o bastante para valer digitar (eventos, concursos, cursos), use
 * `<SearchableSelect size="sm">` dentro de um `FilterField` em vez deste.
 */
export default function FilterSelect({ label, emptyLabel = 'Todos', flex, maxW, minW, ...rest }: IFilterSelectProps) {
  return (
    <FilterField label={label} flex={flex} maxW={maxW} minW={minW}>
      <FormSelect size={FILTER_CONTROL_SIZE} placeholder={emptyLabel} {...rest} />
    </FilterField>
  )
}
